export default __webpack_public_path__ + "static/media/b-lock.22b84633.svg";